import { render, staticRenderFns } from "./InitNotification.vue?vue&type=template&id=604e3098&"
import script from "./InitNotification.vue?vue&type=script&lang=js&"
export * from "./InitNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports